import axios from "axios";
export function request(config, 
// we use 'payload' to enable non-ts applications to leverage type safety and
// as a argument sugar that allow us to extract the payload type easily
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_payload) {
    // we also ignore it here, so the payload value won't propagate as a possible
    // undefined, where its default value is actually `null`.
    return config;
}
export function createRequestError(error) {
    var _a, _b, _c;
    var data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
    var code = 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    ((_b = data) === null || _b === void 0 ? void 0 : _b.code) || (error === null || error === void 0 ? void 0 : error.code) || ((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status);
    return {
        code: code,
        data: data,
        message: error === null || error === void 0 ? void 0 : error.message,
        isCancel: axios.isCancel(error),
        original: error,
    };
}
